import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'page-'

export default {
  path: '/page',
  name: 'page',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '静态页面',
      },
      component: () => import('@/views/page/list'),
    },
  ],
}
